import React from "react"
import { Button, FormGroup, FormControl, Label } from "react-bootstrap"
import { SelectNetworkURL } from './SelectNetworkURL'
import {  instance} from '../../variables/Config'
import { DigmaNetwork, HostUrl, ProjectName, ProjectSlogan, } from '../../variables/DigmaDef'

import YSpinner from '../../elements/Spinner/Spinner'
//import { SpeedTest } from './SpeedTest'
//import { AppConfigContext } from '../../AppConfigContext'

class Login extends React.Component {
  constructor(props) {
    super(props);
    this._isMounted = false;

    this.state = {
      hosturl: DigmaNetwork ? "" : HostUrl,
      //branch: "",
      email: "",
      password: "",
      nomatch: false,
      get_token: false,
      token_val:"",
      token:"",
      speedTest: ""
    }
    //this.selectBranch = this.selectBranch.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.validateForm = this.validateForm.bind(this)
  }
  
  componentDidMount(){
    this._isMounted =  true;
    //this.setState({speedTest: speedTest()}) // , hosturl: instance.get_mainDomain()
  }

  validateForm = () => {
    return this.state.email.length > 0 && this.state.password.length > 0  // && this.state.branch.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    })
  }
  
  handleSubmit = event => {
    event.preventDefault()
    const {hosturl, email, password} = this.state
    //let res = this.verifyLogin(this.state.email, this.state.password)
    //this.props.loginres(res)
    // if (!DevBuild)
    this.props.hosturl(hosturl) // set application url
    //instance.set_mainDomain(hosturl) 

    this.getToken(hosturl, email, password) // , this.state.branch)
  }
  getToken = (url, username,password) => { // }, branch){
    //inUpdate(true)
    this.setState({get_token:true})
    let body ={
     //   branch: branch,
        username: username,
        password: password
    }
    //let url = this.state.hosturl
   
    //fetch('https://digma.me/wp-json/jwt-auth/v1/token', {
     // fetch(HostUrl + '/wp-json/jwt-auth/v1/token', { instance.get_mainDomain()
     //fetch(instance.get_mainDomain() + '/wp-json/jwt-auth/v1/token', { 
      fetch(url + '/wp-json/jwt-auth/v1/token', { 
        method: 'POST',
        headers: {
          'Content-Type': 'multipart/form-data'//,  'HTTP_Authorization': 'OAuth 2.0' //,
        },
        body: JSON.stringify({body}) 
      }).then(response => {
          if (response.ok) {
              const token_val = response.clone().json()
              if (!this._isMounted)   return null
              this.setState({token_val: token_val, get_token:false, nomatch:false})
              //this.props.loginres(token_val)
              //alert("token ="+response.json())
              //console.log("got ok token", token_val )
              return token_val
          } /*else if (response.status === 403) {
            console.log('login status 403 - not found??')
            throw new Error('403')
          } */else {
              if (!this._isMounted)   return null
              this.setState({get_token:false, nomatch:true})
              throw new Error('Fetch token status='+ response.status + ' data=', body)
          }
      }).then(token_val => {
        this.setState({token:token_val})
        this.props.loginres(token_val)

        //console.log("get token token val", token_val['token'])
        return token_val.token
      }).catch(restError => {
          console.log ('login fail = ' + restError)
      })
  
  }
  componentWillUnmount(){
    this._isMounted = false
  }
  //static contextType = AppConfigContext
  setUrl = (hosturl) => {
    this.setState({hosturl})
    instance.set_mainDomain(hosturl)
  }
  render() {
    //console.log('Context = ' + this.context)
    if (this.state.get_token){
      //console.log("this satte", this.state)
      return <YSpinner message={"מתחבר למערכת"} />
    }
    //if (this.state.get_token === false)
    //  console.log('this state whats up?', this.state)

    if (this.state.token_val && !this.state.nomatch) // prevent redundant render
      return null
 
    return (
      <div style={{textAlign:'center',direction:'rtl'}} className="login-page">
        <h1 className="login-title">
          <span className="first-title">{ProjectName}</span><br />
          <span className="second-title">{ProjectSlogan}</span>
        </h1>
        <p className="login-intro">ברוכים הבאים למערכת {ProjectName}<br />
        הכניסה למשתמשים מורשים בלבד</p>
        {DigmaNetwork && <SelectNetworkURL setUrl={this.setUrl} />}       
        
        <form className="login-form" >
          <FormGroup controlId="email" className="large">
            <Label>שם או כתובת דוא"ל</Label>
            <FormControl autoFocus type="email" value={this.state.email} onChange={this.handleChange} />
          </FormGroup>
          <FormGroup controlId="password" className="large">
            <Label>סיסמא</Label>
            <FormControl type="password" value={this.state.password} onChange={this.handleChange} />
          </FormGroup>
          {this.state.nomatch ? <span>כתובת או סיסמא שגויים</span> : null}
          <Button block className="large" disabled={!this.validateForm()} 
                onClick={this.handleSubmit} type="button">כניסה למערכת</Button>
        </form>
        <ul className="ul-usefull usefull-links">
          <li><a href={this.state.hosturl+"/parentq"} target="_blank" rel="noopener noreferrer">שאלון עמדות להורה</a></li>
          <li><a href={this.state.hosturl+"/parentp"} target="_blank" rel="noopener noreferrer">שאלון מוצרים ושרותים</a></li>
        </ul>
        {/*<SpeedTest />*/}
      </div>
    )
  }
}

export default  Login


/* STRANGE CODE
// if network...
export const Branches = ['https://tms.digma.me', 'd1', 'd2', 'd3'] // Netword branches - main is always first!
export const BranchNames = ['ראשי', 'דרום', 'מרכז', 'צפון'] // Netword branches - main is always first!

///////// Only one is active
//export const HostUrl = "https://t.digma.me" // testing PRODUCTION
//export const HostUrl = "https://d.digma.me" // demo site
//export const HostUrl = "https://digma.me" // PRODUCTION




// set by user selection in login form
// used by all server access - fetch etc...

class UrlConfig {
    constructor(){
        if (!UrlConfig.instance){
            this.host_url = MainDomain
            this.branch = 'cvb'
            UrlConfig.instance = this
        }
        return UrlConfig.instance
    }
    set_mainDomain(value){
        this.host_url = value.includes('https://') ? value : 'https://' + value + '.' + Branches[0].replace('https://','')
        console.log('UrlConfig Set_mainDomain value=' + value + 'host_url=' + this.host_url)
        return this.host_url
    }
    get_mainDomain(){
        console.log('UrlConfig Get_mainDomain=', this.host_url)
        return this.host_url
    }
    //instance.get_endPoint(StatsNowEPmboNew)
    get_endPoint(point) {
        console.log('UrlConfig get_endPoint=', this.host_url + point)
        return this.host_url + point
    }
}

export const instance = new UrlConfig()

export const HostUrl = instance.get_mainDomain() // 'https://d1.tms.digma.me' // 
})
     // this.setState({mounted:true})
  }
  */